import {ILeadSummaryItem} from "../../../lead/types/ILeadSummaryItem";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IVendorDetailApplication} from "../../../vendor/types/IVendorDetailApplication";
import {IAdditionalData} from "../../reducers/application_reducer";

interface IParams {
    offer: IAdditionalData<IOfferDetailApplication> | null;
    vendor: IAdditionalData<IVendorDetailApplication> | null;
    isPriceRevealed?: boolean;
}

export function transformLeadDataOfferIntoLeadSummaryItem(params: IParams) {
    const {offer: offerData, vendor: vendorData, isPriceRevealed} = params;
    const offer = offerData?.detail;
    const vendor = vendorData?.detail;

    if (!offer || !vendor) {
        return null;
    }

    return {
        mainImage: {
            desktop: offer.main_image.m_img_375x211,
            mobile: offer.main_image.m_img_375x211
        },
        offerType: offer.type,
        offerName: offer.name,
        region: offer.region,
        offerVendorName: vendor.name,
        offerAddress: offer.address,
        isPriceRevealed
    } as Omit<ILeadSummaryItem, "regionEstimatedPriceSummary">;
}
import {ILeadSummaryItem} from "../../../lead/types/ILeadSummaryItem";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IVendorDetailApplication} from "../../../vendor/types/IVendorDetailApplication";
import {IAdditionalData} from "../../reducers/application_reducer";

interface IParams {
    offer: IAdditionalData<IOfferDetailApplication> | null;
    vendor: IAdditionalData<IVendorDetailApplication> | null;
    isPriceRevealed?: boolean;
}

export function transformLeadDataOfferIntoLeadSummaryItem(params: IParams) {
    const {offer: offerData, vendor: vendorData, isPriceRevealed} = params;
    const offer = offerData?.detail;
    const vendor = vendorData?.detail;

    if (!offer || !vendor) {
        return null;
    }

    return {
        mainImage: {
            desktop: offer.main_image.m_img_375x211,
            mobile: offer.main_image.m_img_375x211
        },
        offerType: offer.type,
        offerName: offer.name,
        region: offer.region,
        offerVendorName: vendor.name,
        offerAddress: offer.address,
        isPriceRevealed
    } as Omit<ILeadSummaryItem, "regionEstimatedPriceSummary">;
}
